// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"a53e646d","680":"ea8b5be0","709":"4437ba7c"}[chunkId] + ".chunk.js";
};